export const initialContentArticle = {
  status: true,
  title: '',
  groups: [],
};
